import { ComponentType, type IConfig } from '../../types';
import { ComponentConfigType } from '../../utils/data-parser';
import {
  BASIC_SELECT_VALUE_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.FormTabs,
  configGroups: [
    {
      title: 'Component Properties',
      items: [
        {
          name: 'type',
          label: 'Type',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Line', value: 'line' },
              { label: 'Card', value: 'card' },
            ],
            defaultValue: 'line',
          },
          configTypes: [ComponentConfigType.Value],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
          ],
        },
        {
          name: 'size',
          label: 'Size',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Small', value: 'small' },
              { label: 'Middle', value: 'middle' },
              { label: 'Large', value: 'large' },
            ],
          },
          configTypes: [ComponentConfigType.Value],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
          ],
        },
        {
          name: 'tabPosition',
          label: 'Tab Position',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Top', value: 'top' },
              { label: 'Right', value: 'right' },
              { label: 'Bottom', value: 'bottom' },
              { label: 'Left', value: 'left' },
            ],
            defaultValue: 'top',
          },
          configTypes: [ComponentConfigType.Value],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
          ],
        },
        {
          name: 'centered',
          label: 'Centered',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [ComponentConfigType.Value],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
          ],
        },
      ],
    },
    {
      title: 'Tab Panes',
      component: 'TabPanesConfigPanel',
    },
    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
  ],
};
